// extracted by mini-css-extract-plugin
module.exports = {"other__events__wrapper":"styles_other__events__wrapper__2KunS"};